import { render, staticRenderFns } from "./JGView.vue?vue&type=template&id=4ba884a4&"
import script from "./JGView.vue?vue&type=script&lang=ts&"
export * from "./JGView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports